/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "ba25b079ca66c82537ced0d75a1481bf529a0f2b";
